import React from 'react';
import * as echarts from 'echarts/core';
import {
    RadarChart as EChartsRadarChart,
} from 'echarts/charts';
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import EchartsWrapper from '@/components/echartsWrapper';

// 注册必要的组件
echarts.use([
    EChartsRadarChart,
    TooltipComponent,
    LegendComponent,
    TitleComponent,
    CanvasRenderer,
]);



interface RadarChartProps {
    data?: Array<{
        name: string;
        value: number[];
    }>;
    indicators?: Array<{
        name: string;
        max: number;
    }>;
    title?: string;
    style?: React.CSSProperties;
}

const RadarChart: React.FC<RadarChartProps> = ({
    data,
    indicators = [
        { name: '精神状态', max: 100 },
        { name: '设备预警', max: 100 },
        { name: '工作强度', max: 100 },
        { name: '驾驶习惯', max: 100 },
        { name: '线路安全', max: 100 }
    ],
    title = '车辆综合评估',
    style = { width: '100%', height: '400px' }
}) => {
    const chartOption = {
        title: {
            text: title,
            left: 'center',
            textStyle: {
                fontSize: 16,
                fontWeight: 'bold'
            }
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            top: 'middle'
        },
        radar: {
            indicator: indicators,
            center: ['50%', '55%'],
            radius: '60%',
            name: {
                textStyle: {
                    color: '#666',
                    fontSize: 12
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#e6e6e6'
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#e6e6e6'
                }
            }
        },
        series: [
            {
                type: 'radar',
                data: data,
                itemStyle: {
                    normal: {
                        borderRadius: 5
                    }
                },
                lineStyle: {
                    width: 2
                },
                areaStyle: {
                    opacity: 0.3
                }
            }
        ]
    };

    return <>
        {data ?
            (<EchartsWrapper
                chartOption={chartOption}
                style={style}
            />)
            : <div>
                <h4>{title}</h4>
                <p>暂无数据</p>
            </div>
        }
    </>
};

export default RadarChart;